import { SectionHeader } from '@/components/ui/SectionHeader'
import { Reveal } from '@/components/ui/Reveal'
import { areas } from '@/data/chronic-health-content'

export const ChronicHealthOverview = () => (
  <section className="bg-base-50 py-16 sm:py-20 lg:py-24">
    <div className="mx-auto max-w-5xl px-6">
      <SectionHeader
        title="Long-term health,"
        accent="considered carefully."
        description="Kandake takes a whole-person approach to long-term health concerns, considering your history, nutrition, lifestyle, emotional wellbeing, and current medical care before recommending appropriate herbal support."
      />
      <ul className="grid gap-5 sm:grid-cols-2">
        {areas.map(({ title, icon: Icon }, index) => (
          <li key={title}>
            <Reveal delay={index * 80} className="h-full">
              <div className="flex h-full items-center gap-5 rounded-3xl border border-base-200 bg-white p-6 transition-colors hover:border-green-300">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-green-50 text-green-700">
                  <Icon aria-hidden="true" className="h-5 w-5" />
                </span>
                <h3 className="font-display text-xl text-base-900">{title}</h3>
              </div>
            </Reveal>
          </li>
        ))}
      </ul>
      <Reveal>
        <p className="mt-8 rounded-2xl border border-gold-200 bg-gold-50 p-5 text-sm leading-6 text-base-700">
          Herbal support complements appropriate medical care and is not a replacement for diagnosis
          or prescribed treatment.
        </p>
      </Reveal>
    </div>
  </section>
)
